import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class SonyNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Sony...');
    return this.onlineByAjax();
  }

}

export default SonyNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/sony/NetworkStatus.js